import {MdSecurity, MdAdd} from 'react-icons/md'

interface PasskeyBackupRecommendationProps {
    credentialCount: number
    onAddPasskey: () => void
}

/**
 * Component that recommends adding backup passkeys
 * Shows when user has only 1 passkey registered
 */
export function PasskeyBackupRecommendation({
                                                credentialCount,
                                                onAddPasskey
                                            }: PasskeyBackupRecommendationProps): JSX.Element | null {

    // Only show if user has exactly 1 passkey
    if (credentialCount !== 1) {
        return null
    }

    return (
        <div className="bg-blue-50 border border-blue-200 rounded-lg px-6 pt-5 pb-6 mb-0">
            {/* Header with icon */}
            <div className="flex items-center mb-1.5">
                <MdSecurity className="text-2xl text-blue-600 ml-0.5 flex-shrink-0"/>
                <h4 className="m-0 text-base font-semibold text-blue-800 pl-5">
                    Add a Backup Passkey
                </h4>
            </div>

            {/* Description */}
            <p className="text-sm text-blue-700 leading-relaxed m-0 mb-3 pl-[46px]">
                You have one passkey set up. Add a backup so you don't get locked out if you lose your device.
            </p>

            {/* Add button */}
            <div className="pl-[46px]">
                <button
                    type="button"
                    onClick={onAddPasskey}
                    className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white border-0 rounded text-sm font-medium cursor-pointer transition-colors"
                >
                    <MdAdd className="text-lg"/>
                    <span>Add Backup Passkey</span>
                </button>
            </div>
        </div>
    )
}

/**
 * Minimal inline prompt for backup passkey
 */
export function PasskeyBackupPromptInline({
                                              onAddPasskey
                                          }: {
    onAddPasskey: () => void
}): JSX.Element {
    return (
        <div className="flex items-center justify-between bg-blue-50 border border-blue-200 rounded p-3">
            <div className="flex items-center space-x-2">
                <MdSecurity className="text-blue-500"/>
                <span className="text-sm text-blue-800">
          <strong>Tip:</strong> Add a backup passkey to prevent lockouts
        </span>
            </div>
            <button
                onClick={onAddPasskey}
                className="text-sm text-blue-600 hover:text-blue-700 font-medium"
            >
                Add now →
            </button>
        </div>
    )
}
